import { filterClientsByQuery as e } from "../helpers/filter-clients-by-query.js";
import { findClient as t } from "../helpers/find-client.js";
import { operationToHar as n } from "../helpers/operation-to-har/operation-to-har.js";
import { generateCodeSnippet as ee } from "../helpers/generate-code-snippet.js";
import { getCustomCodeSamples as te } from "../helpers/get-custom-code-samples.js";
import { getClients as r } from "../helpers/get-clients.js";
import { getSecrets as i } from "../helpers/get-secrets.js";
import ne from "./ExamplePicker.vue.js";
import a from "./HttpMethod.vue.js";
import { Fragment as o, computed as s, createBlock as c, createCommentVNode as l, createElementBlock as u, createElementVNode as d, createSlots as re, createTextVNode as f, createVNode as p, defineComponent as m, onBeforeMount as ie, openBlock as h, ref as g, renderSlot as _, toDisplayString as v, unref as y, useId as b, watch as x, watchEffect as ae, withCtx as S } from "vue";
import { ScalarButton as C } from "@scalar/components/button";
import { ScalarCard as w, ScalarCardFooter as oe, ScalarCardHeader as se, ScalarCardSection as T } from "@scalar/components/card";
import { ScalarCodeBlock as ce } from "@scalar/components/code-block";
import { ScalarCombobox as le } from "@scalar/components/combobox";
import { ScalarVirtualText as ue } from "@scalar/components/virtual-text";
import { freezeElement as de } from "@scalar/helpers/dom/freeze-element";
import { ScalarIconCaretDown as E } from "@scalar/icons";
import { getResolvedRef as D } from "@scalar/workspace-store/helpers/get-resolved-ref";
import { getOperationExamples as O, resolveOperationExamples as k } from "@scalar/workspace-store/helpers/operation-examples";
import { useExampleVisibility as A, useExternalExamples as j } from "@scalar/workspace-store/helpers/use-external-examples";
//#region src/code-example/components/CodeExample.vue?vue&type=script&setup=true&lang.ts
var M = ["innerHTML"], N = {
	key: 1,
	class: "text-c-2 flex h-full w-fit items-center px-0.5 py-0 text-base font-normal",
	"data-testid": "client-picker"
}, P = {
	key: 0,
	class: "text-c-2 p-4",
	role: "status"
}, F = {
	key: 1,
	class: "text-c-2 p-4",
	role: "status"
}, I = ["id"], L = {
	key: 0,
	class: "request-card-footer-addon"
}, R = { class: "request-header" }, z = /*@__PURE__*/ m({
	__name: "CodeExample",
	props: {
		codeSampleUnavailable: { default: "No code sample available for this example." },
		clientPickerLabel: { default: "Change code sample language" },
		clientSearchLabel: { default: "Search clients" },
		codeSampleLabel: { default: "Code sample" },
		integration: {},
		clientOptions: {},
		selectedClient: {},
		selectedServer: { default: null },
		selectedContentType: {},
		selectedExample: {},
		eventBus: {},
		securitySchemes: { default: () => [] },
		method: {},
		path: {},
		operation: {},
		fallback: { type: Boolean },
		generateLabel: { type: Function },
		isWebhook: { type: Boolean },
		globalCookies: {},
		openapiVersion: {},
		requestBodyCompositionSelection: {}
	},
	emits: ["update:exampleKey"],
	setup(m, { emit: z }) {
		let B = z, V = s(() => {
			let e = D(m.operation.requestBody)?.content ?? {}, t = m.selectedContentType || Object.keys(e)[0];
			return t ? e[t]?.examples ?? {} : {};
		}), H = g(""), U = (e) => {
			let t = Object.keys(V.value);
			return e && t.includes(e) ? e : H.value && t.includes(H.value) ? H.value : t[0] ?? "";
		};
		ie(() => {
			H.value = U(m.selectedExample);
		}), x(() => m.selectedExample, (e) => {
			H.value = U(e);
		}), x(() => m.selectedContentType, () => {
			Object.keys(V.value).includes(H.value) || (H.value = U(m.selectedExample));
		}), ae(() => {
			B("update:exampleKey", H.value);
		});
		let fe = (e) => {
			H.value = e, m.eventBus.emit("workspace:update:selected-example", e);
		}, W = s(() => te(m.operation)), G = s(() => r(W.value.samples, m.clientOptions, W.value.label)), K = s(() => G.value.reduce((e, t) => e + t.options.length, 0)), q = g(t(G.value, m.selectedClient));
		x([() => m.selectedClient, G], ([e]) => {
			let n = t(G.value, e);
			n && (q.value = n);
		});
		let pe = s(() => [m.clientPickerLabel, q.value?.title].filter(Boolean).join(": ")), me = s(() => [m.codeSampleLabel, q.value?.title].filter(Boolean).join(": ")), J = g(null), he = A(J), Y = j(() => O(m.operation, H.value, m.selectedContentType), () => he.value), X = s(() => k(m.operation, H.value, m.selectedContentType, Y.resolve)), Z = s(() => Object.keys(V.value).length > 1), Q = s(() => {
			if (!m.isWebhook) return null;
			try {
				return n({
					operation: X.value,
					method: m.method,
					path: m.path,
					example: H.value,
					openapiVersion: m.openapiVersion,
					requestBodyCompositionSelection: m.requestBodyCompositionSelection,
					defaultDisabledParameters: !0
				});
			} catch (e) {
				return console.error("[webhookHar]", e), null;
			}
		}), $ = s(() => m.isWebhook ? Q.value?.postData?.text ?? "" : ee({
			defaultDisabledParameters: !0,
			includeDefaultHeaders: m.integration === "client",
			clientId: q.value?.id,
			customCodeSamples: W.value.samples,
			operation: X.value,
			method: m.method,
			path: m.path,
			contentType: m.selectedContentType,
			server: m.selectedServer,
			securitySchemes: m.securitySchemes,
			example: H.value,
			globalCookies: m.globalCookies,
			openapiVersion: m.openapiVersion,
			requestBodyCompositionSelection: m.requestBodyCompositionSelection
		})), ge = s(() => m.isWebhook ? _e.value : q.value?.lang), _e = s(() => {
			if (!Q.value?.postData) return "json";
			let e = Q.value.postData.mimeType;
			return e?.includes("json") ? "json" : e?.includes("xml") ? "xml" : e?.includes("yaml") || e?.includes("yml") ? "yaml" : e?.includes("text/plain") ? "text" : "json";
		}), ve = s(() => i(m.securitySchemes)), ye = (e) => {
			if (J.value) {
				let e = de(J.value.$el);
				setTimeout(() => {
					e();
				}, 300);
			}
			q.value = e, e && m.eventBus.emit("workspace:update:selected-client", e.id);
		}, be = s(() => ($.value?.length ?? 0) > 2e4), xe = b();
		return (t, n) => $.value === null || $.value || y(Y).pending.value ? (h(), c(y(w), {
			key: 0,
			ref_key: "elem",
			ref: J,
			class: "request-card dark-mode"
		}, {
			default: S(() => [
				p(y(se), { class: "pr-2.5" }, re({
					default: S(() => [
						n[1] ||= d("span", { class: "sr-only" }, "Request Example for", -1),
						p(a, {
							as: "span",
							class: "request-method",
							method: m.method
						}, null, 8, ["method"]),
						m.generateLabel ? (h(), u("span", {
							key: 0,
							innerHTML: m.generateLabel()
						}, null, 8, M)) : l("", !0),
						_(t.$slots, "header", {}, void 0, !0)
					]),
					_: 2
				}, [!m.isWebhook && K.value ? {
					name: "actions",
					fn: S(() => [K.value > 1 ? (h(), c(y(le), {
						key: 0,
						class: "max-h-80",
						filterFn: y(e),
						inputLabel: m.clientSearchLabel,
						modelValue: q.value,
						options: G.value,
						placement: "bottom-end",
						teleport: "",
						"onUpdate:modelValue": n[0] ||= (e) => ye(e)
					}, {
						default: S(() => [p(y(C), {
							"aria-label": pe.value,
							class: "text-c-2 hover:text-c-1 flex h-full w-fit gap-1.5 px-0.5 py-0 text-base font-normal",
							"data-testid": "client-picker",
							variant: "ghost"
						}, {
							default: S(() => [f(v(q.value?.title) + " ", 1), p(y(E), {
								class: "ui-open:rotate-180 mt-px size-3 transition-transform duration-100",
								weight: "bold"
							})]),
							_: 1
						}, 8, ["aria-label"])]),
						_: 1
					}, 8, [
						"filterFn",
						"inputLabel",
						"modelValue",
						"options"
					])) : (h(), u("span", N, v(q.value?.title), 1))]),
					key: "0"
				} : void 0]), 1024),
				p(y(T), { class: "request-editor-section custom-scroll p-0" }, {
					default: S(() => [y(Y).pending.value ? (h(), u("div", P, [y(Y).failed.value ? (h(), u(o, { key: 0 }, [n[3] ||= f(" Could not load this example. ", -1), p(y(C), {
						size: "sm",
						variant: "ghost",
						onClick: y(Y).retry
					}, {
						default: S(() => [...n[2] ||= [f(" Retry ", -1)]]),
						_: 1
					}, 8, ["onClick"])], 64)) : (h(), u(o, { key: 1 }, [f("Loading example…")], 64))])) : $.value === null ? (h(), u("div", F, v(m.codeSampleUnavailable), 1)) : (h(), u("div", {
						key: 2,
						id: `${y(xe)}-example`,
						class: "code-snippet"
					}, [be.value ? (h(), c(y(ue), {
						key: 1,
						"aria-label": "Request code sample",
						containerClass: "custom-scroll scalar-code-block border rounded-b flex flex-1 max-h-screen",
						contentClass: "language-plaintext whitespace-pre font-code text-base p-2",
						lineHeight: 20,
						role: "region",
						text: $.value
					}, null, 8, ["text"])) : (h(), c(y(ce), {
						key: 0,
						class: "bg-b-2 h-full",
						content: $.value,
						hideCredentials: ve.value,
						label: me.value,
						lang: ge.value,
						lineNumbers: ""
					}, null, 8, [
						"content",
						"hideCredentials",
						"label",
						"lang"
					]))], 8, I))]),
					_: 1
				}),
				Z.value || t.$slots.footer ? (h(), c(y(oe), {
					key: 0,
					class: "request-card-footer bg-b-3"
				}, {
					default: S(() => [Z.value ? (h(), u("div", L, [Object.keys(V.value).length ? (h(), c(ne, {
						key: 0,
						examples: V.value,
						modelValue: H.value,
						"onUpdate:modelValue": fe
					}, null, 8, ["examples", "modelValue"])) : l("", !0)])) : l("", !0), _(t.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
					_: 3
				})) : l("", !0)
			]),
			_: 3
		}, 512)) : m.fallback ? (h(), c(y(w), {
			key: 1,
			class: "request-card dark-mode"
		}, {
			default: S(() => [p(y(T), { class: "request-card-simple" }, {
				default: S(() => [d("div", R, [p(a, {
					as: "span",
					class: "request-method",
					method: m.method
				}, null, 8, ["method"]), _(t.$slots, "header", {}, void 0, !0)]), _(t.$slots, "footer", { exampleName: H.value }, void 0, !0)]),
				_: 3
			})]),
			_: 3
		})) : l("", !0);
	}
});
//#endregion
export { z as default };

//# sourceMappingURL=CodeExample.vue.script.js.map